import { IconButton } from '@material-ui/core';
import styled from 'styled-components';

export const StatusItems = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin: 0 0 0 auto;
  flex-wrap: wrap;
`;

export const RefundIconButton = styled(IconButton)`
  &.MuiIconButton-root,
  &.MuiButtonBase-root {
    font-size: 10px;
    color: #949494;
    border: 2px solid #949494;
    font-weight: 700;
    padding: 4px 10px;
    border-radius: 8px;
    text-align: center;
    cursor: default;
    height: 27px;
    cursor: pointer;
  }

  span {
    gap: 4px;
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;
